{
  "addons.addonList": "Llista de complements",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Creeu i obteniu la vostra clau API des d'aquest enllaç",
  "addons.ambientWeatherDescription": "Estacions Ambient Weather (WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "Clau API",
  "addons.applicationKey": "Clau d'aplicació",
  "addons.connect": "Connecta",
  "addons.davisApiSecret": "Secret API",
  "addons.davisApiV2Key": "Clau API V2",
  "addons.davisDescription": "Estacions meteorològiques Davis (Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "Obteniu les vostres claus API V2 des d'aquest enllaç",
  "addons.disconnect": "Desconnecta",
  "addons.ecowittCreateAndRetrieveKeys": "Creeu i obteniu una clau API i una clau d'aplicació des d'aquest enllaç",
  "addons.ecowittDescription": "Ecowitt ofereix estacions meteorològiques wifi professionals, termòmetres sense fil per a interior i exterior, monitors d'humitat, pluviòmetres d'alta precisió, monitors de qualitat de l'aire i molt més.",
  "addons.helpLink": "Com connectar {provider}",
  "addons.myAcuriteAccountOnHold": "El vostre compte s'ha posat en espera. Introduïu la vostra contrasenya per tornar a connectar el compte",
  "addons.myAcuriteDescription": "AcuRite és la marca d'estacions meteorològiques número 1 a Amèrica del Nord. Com a líder en tecnologia de temps, temperatura i meteorologia, AcuRite us proporciona informació detallada sobre el vostre entorn interior i exterior perquè pugueu planificar el vostre dia amb confiança.",
  "addons.myAcuriteEnterCredentials": "Introduïu les vostres credencials de My AcuRite per enllaçar el vostre compte de My AcuRite amb SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Utilitzeu el vostre termòstat Netatmo per canviar la temperatura de casa vostra, des del llit o des de l'altra punta del món.",
  "addons.netatmoThermostat": "Termòstat Netatmo",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "La vostra estació meteorològica personal a casa",
  "addons.or": "o",
  "addons.providerAccountDisconnected": "La connexió amb el vostre servei meteorològic ha caducat. Torneu a connectar-vos per reprendre les actualitzacions de dades.",
  "addons.reconnect": "Torna a connectar",
  "addons.weatherflowCreateToken": "Creeu i obteniu el vostre testimoni des d'aquest enllaç",
  "addons.weatherflowTempestDescription": "Sistema meteorològic Tempest amb anemòmetre i pluviòmetre integrats",
  "addons.wundergroundApiKey": "Clau API",
  "addons.wundergroundDescription": "Weather Underground és una comunitat global de persones que connecten dades de sensors ambientals com estacions meteorològiques i monitors de qualitat de l'aire perquè puguem oferir les dades riques i hiperlocals que necessiteu per alimentar les vostres passions",
  "addons.wundergroundRetrieveApiKey": "Obteniu la vostra clau API des d'aquest enllaç",
  "addons.wundergroundRetrieveStationId": "Obteniu l'identificador de la vostra estació des d'aquest enllaç",
  "addons.wundergroundStationId": "Identificador de l'estació",
  "airQuality.airQuality": "Qualitat de l'aire",
  "airQuality.airQualityIndex": "Índex de qualitat de l'aire",
  "airQuality.aqiForecast": "Previsió de l'AQI",
  "airQuality.co": "Monòxid de carboni",
  "airQuality.dailyForecast": "Previsió diària",
  "airQuality.details": "Detalls",
  "airQuality.dominantPollutant": "Contaminant dominant",
  "airQuality.good": "Bona",
  "airQuality.goodDescription": "La qualitat de l'aire es considera satisfactòria i la contaminació atmosfèrica presenta poc o cap risc",
  "airQuality.hazardous": "Perillosa",
  "airQuality.hazardousDescription": "Alerta sanitària: tothom pot experimentar efectes més greus per a la salut",
  "airQuality.indoorAirQuality": "Qualitat de l'aire interior",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Moderada",
  "airQuality.moderateDescription": "La qualitat de l'aire és acceptable; tanmateix, per a alguns contaminants pot haver-hi una preocupació sanitària moderada per a un nombre molt reduït de persones especialment sensibles a la contaminació atmosfèrica.",
  "airQuality.no2": "Diòxid de nitrogen",
  "airQuality.o3": "Ozó",
  "airQuality.pm10": "Partícules amb un diàmetre de 10 μm o menys",
  "airQuality.pm25": "Partícules amb un diàmetre de 2,5 μm o menys",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Perjudicial per a persones sensibles",
  "airQuality.sensitiveUnhealthyDescription": "Els membres dels grups sensibles poden experimentar efectes per a la salut. És poc probable que el públic general es vegi afectat.",
  "airQuality.so2": "Diòxid de sofre",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Perjudicial",
  "airQuality.unhealthyDescription": "Tothom pot començar a experimentar efectes per a la salut; els membres dels grups sensibles poden experimentar efectes més greus",
  "airQuality.veryUnhealthy": "Molt perjudicial",
  "airQuality.veryUnhealthyDezscription": "Advertiments sanitaris de condicions d'emergència. És més probable que tota la població es vegi afectada.",
  "alerts.addAlert": "Afegeix una alerta",
  "alerts.addCondition": "Afegeix una condició",
  "alerts.alertAdded": "Alerta afegida correctament",
  "alerts.alertAuthorizationNotice": "Les alertes només funcionen si autoritzeu SmartMixin a mostrar notificacions",
  "alerts.alertDeleted": "Alerta eliminada correctament",
  "alerts.alertEdited": "Alerta modificada correctament",
  "alerts.alertName": "Nom de l'alerta",
  "alerts.alertWhen": "Vull rebre una alerta quan:",
  "alerts.aqiGreaterThan": "AQI superior a",
  "alerts.aqiGreaterThanThreshold": "AQI superior al llindar de {value}{unit}",
  "alerts.aqiLessThan": "AQI inferior a",
  "alerts.aqiLessThanThreshold": "AQI inferior al llindar de {value}{unit}",
  "alerts.atLeastOneCondition": "Cal afegir almenys una condició",
  "alerts.co2GreaterThan": "CO2 superior a",
  "alerts.co2GreaterThanThreshold": "CO2 superior al llindar de {value}{unit}",
  "alerts.co2LessThan": "CO2 inferior a",
  "alerts.co2LessThanThreshold": "CO2 inferior al llindar de {value}{unit}",
  "alerts.conditions": "Condicions",
  "alerts.createAlert": "Crea una alerta",
  "alerts.dailyPrecipitationGreaterThan": "Precipitació diària superior a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitació diària superior al llindar de {value}{unit}",
  "alerts.deleteAlert": "Elimina l'alerta",
  "alerts.editAlert": "Edita l'alerta",
  "alerts.editCondition": "Edita la condició",
  "alerts.gustSpeedGreaterThan": "Velocitat de ràfega superior a",
  "alerts.gustSpeedGreaterThanThreshold": "Velocitat de ràfega superior al llindar de {value}{unit}",
  "alerts.gustSpeedLessThan": "Velocitat de ràfega inferior a",
  "alerts.gustSpeedLessThanThreshold": "Velocitat de ràfega inferior al llindar de {value}{unit}",
  "alerts.heatIndexGreaterThan": "Índex de calor superior a",
  "alerts.heatIndexGreaterThanThreshold": "Índex de calor superior al llindar de {value}{unit}",
  "alerts.heatIndexLessThan": "Índex de calor inferior a",
  "alerts.heatIndexLessThanThreshold": "Índex de calor inferior al llindar de {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex superior a",
  "alerts.humidexGreaterThanThreshold": "Humidex superior al llindar de {value}{unit}",
  "alerts.humidexLessThan": "Humidex inferior a",
  "alerts.humidexLessThanThreshold": "Humidex inferior al llindar de {value}{unit}",
  "alerts.humidityGreaterThan": "Humitat superior a",
  "alerts.humidityGreaterThanThreshold": "Humitat superior al llindar de {value}{unit}",
  "alerts.humidityLessThan": "Humitat inferior a",
  "alerts.humidityLessThanThreshold": "Humitat inferior al llindar de {value}{unit}",
  "alerts.inProgress": "En curs",
  "alerts.myAlerts": "Les meves alertes",
  "alerts.noConfiguredAlert": "Encara no teniu cap alerta configurada, comenceu a afegir-ne una",
  "alerts.noiseGreaterThan": "Soroll superior a",
  "alerts.noiseGreaterThanThreshold": "Soroll superior al llindar de {value}{unit}",
  "alerts.noiseLessThan": "Soroll inferior a",
  "alerts.noiseLessThanThreshold": "Soroll inferior al llindar de {value}{unit}",
  "alerts.noteOnConditions": "Tingueu en compte que l'alerta s'activa quan es compleixen totes les condicions següents",
  "alerts.pm10GreaterThan": "PM 10 superior a",
  "alerts.pm10GreaterThanThreshold": "PM 10 superior al llindar de {value}{unit}",
  "alerts.pm10LessThan": "PM 10 inferior a",
  "alerts.pm10LessThanThreshold": "PM 10 inferior al llindar de {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 superior a",
  "alerts.pm1GreaterThanThreshold": "PM 1 superior al llindar de {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inferior a",
  "alerts.pm1LessThanThreshold": "PM 1 inferior al llindar de {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 superior a",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 superior al llindar de {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 inferior a",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 inferior al llindar de {value}{unit}",
  "alerts.postStormSummary": "Resum posterior a la tempesta",
  "alerts.postStormSynopsisHelper": "Rebreu una notificació de resum després que acabi cada tempesta de pluja.",
  "alerts.postStormSynopsisSoleCondition": "Un resum posterior a la tempesta no es pot combinar amb altres condicions.",
  "alerts.precipitationGreaterThan": "Precipitació horària superior a",
  "alerts.precipitationGreaterThanThreshold": "Precipitació horària superior al llindar de {value}{unit}",
  "alerts.pressureGreaterThan": "Pressió superior a",
  "alerts.pressureGreaterThanThreshold": "Pressió superior al llindar de {value}{unit}",
  "alerts.pressureLessThan": "Pressió inferior a",
  "alerts.pressureLessThanThreshold": "Pressió inferior al llindar de {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensitat de pluja superior a",
  "alerts.rainRateGreaterThanThreshold": "Intensitat de pluja superior al llindar de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiació solar superior a",
  "alerts.solarRadiationGreaterThanThreshold": "Radiació solar superior al llindar de {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiació solar inferior a",
  "alerts.solarRadiationLessThanThreshold": "Radiació solar inferior al llindar de {value}{unit}",
  "alerts.temperatureGreaterThan": "Temperatura superior a",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superior al llindar de {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura inferior a",
  "alerts.temperatureLessThanThreshold": "Temperatura inferior al llindar de {value}{unit}",
  "alerts.thswGreaterThan": "THSW superior a",
  "alerts.thswGreaterThanThreshold": "THSW superior al llindar de {value}{unit}",
  "alerts.thswLessThan": "THSW inferior a",
  "alerts.thswLessThanThreshold": "THSW inferior al llindar de {value}{unit}",
  "alerts.thwGreaterThan": "THW superior a",
  "alerts.thwGreaterThanThreshold": "THW superior al llindar de {value}{unit}",
  "alerts.thwLessThan": "THW inferior a",
  "alerts.thwLessThanThreshold": "THW inferior al llindar de {value}{unit}",
  "alerts.uvGreaterThan": "Índex UV superior a",
  "alerts.uvGreaterThanThreshold": "Índex UV superior al llindar de {value}{unit}",
  "alerts.uvLessThan": "Índex UV inferior a",
  "alerts.uvLessThanThreshold": "Índex UV inferior al llindar de {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilitat superior al llindar de {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilitat inferior al llindar de {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilitat superior a",
  "alerts.visiblityLessThan": "Visibilitat inferior a",
  "alerts.whichMeasure": "Per a quina mesura voleu rebre alertes?",
  "alerts.whichModule": "Per a quin mòdul voleu rebre alertes?",
  "alerts.windChillGreaterThan": "Sensació de fred superior a",
  "alerts.windChillGreaterThanThreshold": "Sensació de fred superior al llindar de {value}{unit}",
  "alerts.windChillLessThan": "Sensació de fred inferior a",
  "alerts.windChillLessThanThreshold": "Sensació de fred inferior al llindar de {value}{unit}",
  "alerts.windSpeedGreaterThan": "Velocitat del vent superior a",
  "alerts.windSpeedGreaterThanThreshold": "Velocitat del vent superior al llindar de {value}{unit}",
  "alerts.windSpeedLessThan": "Velocitat del vent inferior a",
  "alerts.windSpeedLessThanThreshold": "Velocitat del vent inferior al llindar de {value}{unit}",
  "astral.astronomicalSunPhase": "{sunPhase} astronòmic",
  "astral.civilSunPhase": "{sunPhase} civil",
  "astral.dawn": "Alba",
  "astral.dusk": "Crepuscle",
  "astral.firstQuarter": "Quart creixent",
  "astral.fullMoon": "Lluna plena",
  "astral.lastQuarter": "Quart minvant",
  "astral.moon": "Lluna",
  "astral.moonPhases": "Fases de la lluna",
  "astral.moonrise": "Sortida de la lluna",
  "astral.moonset": "Posta de la lluna",
  "astral.nauticalSunPhase": "{sunPhase} nàutic",
  "astral.newMoon": "Lluna nova",
  "astral.noon": "Migdia",
  "astral.remainingDaylight": "Llum de dia restant",
  "astral.sunrise": "Sortida del sol",
  "astral.sunriseAndSunset": "Sortida i posta del sol",
  "astral.sunriseAt": "Sortida del sol a les {time}",
  "astral.sunset": "Posta del sol",
  "astral.sunsetAt": "Posta del sol a les {time}",
  "astral.totalDaylight": "Llum de dia total",
  "astral.waningCrescent": "Lluna minvant",
  "astral.waningGibbous": "Gibosa minvant",
  "astral.waxingCrescent": "Lluna creixent",
  "astral.waxingGibbous": "Gibosa creixent",
  "auth.alreadyHaveAccount": "Ja teniu un compte?",
  "auth.authContainerTagline": "El vostre tauler meteorològic personal. Connecteu les vostres estacions i obteniu dades en temps real a l'abast dels dits.",
  "auth.backToLogin": "Torna a l'inici de sessió",
  "auth.catchPhrase": "La plataforma d'intel·ligència meteorològica",
  "auth.checkYourEmail": "Reviseu el vostre correu electrònic",
  "auth.continueWithApple": "Continua amb Apple",
  "auth.continueWithFacebook": "Continua amb Facebook",
  "auth.continueWithGoogle": "Continua amb Google",
  "auth.email": "Adreça electrònica",
  "auth.emailRequiredLoginFacebook": "Cal el permís de correu electrònic.",
  "auth.emailVerification": "Verificació del correu electrònic",
  "auth.emailVerificationFailure": "S'ha produït un problema amb la verificació del vostre correu electrònic.",
  "auth.emailVerificationSuccess": "El vostre correu electrònic s'ha verificat correctament.",
  "auth.firstName": "Nom",
  "auth.forgotPassword": "Heu oblidat la contrasenya?",
  "auth.forgotPasswordSubtitle": "Introduïu el vostre correu electrònic i us enviarem un enllaç per restablir la contrasenya.",
  "auth.lastName": "Cognoms",
  "auth.login": "Inicia la sessió",
  "auth.loginSubtitle": "Ens alegrem de tornar-vos a veure! Introduïu les vostres dades.",
  "auth.loginToSmartMixinDescription": "Inicieu la sessió a SmartMixin per accedir a les vostres estacions meteorològiques, veure analítiques i gestionar el vostre tauler meteorològic personal.",
  "auth.logout": "Tanca la sessió",
  "auth.logoutConfirmation": "Segur que voleu tancar la sessió?",
  "auth.noAccountYet": "Encara no teniu cap compte?",
  "auth.or": "o",
  "auth.password": "Contrasenya",
  "auth.passwordAgain": "Repetiu la contrasenya",
  "auth.passwordReset": "Restabliment de la contrasenya",
  "auth.passwordResetSuccess": "La vostra contrasenya s'ha actualitzat correctament.",
  "auth.register": "Crea un compte",
  "auth.registerDescription": "Creeu un compte gratuït de SmartMixin per connectar les vostres estacions meteorològiques, fer el seguiment de les dades del temps i accedir a potents eines d'analítica.",
  "auth.registerSubtitle": "Creeu el vostre compte per començar.",
  "auth.registerSuccess": "Us heu registrat correctament! Us acabem d'enviar un enllaç de verificació a {emailAddress} amb més instruccions.",
  "auth.restorePassword": "Recupera la contrasenya",
  "auth.restorePasswordSuccess": "Us acabem d'enviar un enllaç per restablir la contrasenya a {emailAddress} amb més instruccions.",
  "auth.sendReset": "Envia les instruccions de restabliment",
  "auth.socialAccount": "o utilitzeu el vostre compte",
  "auth.welcome": "Us donem la benvinguda a SmartMixin",
  "auth.welcomeBack": "Ens alegrem de tornar-vos a veure!",
  "calendar.april": "Abril",
  "calendar.august": "Agost",
  "calendar.dateFormat": "Format de data",
  "calendar.day": "Dia",
  "calendar.december": "Desembre",
  "calendar.end": "Fi",
  "calendar.february": "Febrer",
  "calendar.hours": "Hores",
  "calendar.hoursShort": "h",
  "calendar.january": "Gener",
  "calendar.july": "Juliol",
  "calendar.june": "Juny",
  "calendar.last24Hours": "Últimes 24 hores",
  "calendar.last30Days": "Últims 30 dies",
  "calendar.last7Days": "Últims 7 dies",
  "calendar.march": "Març",
  "calendar.max": "Màx",
  "calendar.may": "Maig",
  "calendar.month": "Mes",
  "calendar.months": "mesos",
  "calendar.november": "Novembre",
  "calendar.october": "Octubre",
  "calendar.oneDay": "1 dia",
  "calendar.oneHour": "1 hora",
  "calendar.oneMonth": "1 mes",
  "calendar.oneWeek": "1 setmana",
  "calendar.previous24Hours": "24 hores anteriors",
  "calendar.previous30Days": "30 dies anteriors",
  "calendar.previous7Days": "7 dies anteriors",
  "calendar.previousDay": "Dia anterior",
  "calendar.previousMonth": "Mes anterior",
  "calendar.previousWeek": "Setmana anterior",
  "calendar.previousYear": "Any anterior",
  "calendar.sameDayLastYear": "Mateix dia de l'any passat",
  "calendar.sameMonthLastYear": "Mateix mes de l'any passat",
  "calendar.selectADate": "Seleccioneu una data",
  "calendar.selectAggregation": "Seleccioneu el valor mostrat",
  "calendar.selectAMonth": "Seleccioneu un mes",
  "calendar.selectAYear": "Seleccioneu un any",
  "calendar.selectGranularity": "Seleccioneu una granularitat",
  "calendar.selectTimescale": "Seleccioneu una escala de temps",
  "calendar.september": "Setembre",
  "calendar.sixHours": "6 hores",
  "calendar.start": "Inici",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 hores",
  "calendar.use24HourFormat": "Utilitza el format de 24 hores",
  "calendar.week": "Setmana",
  "calendar.year": "Any",
  "calendar.yesterday": "Ahir",
  "common.accountDeleted": "El vostre compte s'ha eliminat correctament.",
  "common.accountOnHold": "La connexió del vostre compte ha caducat. Torneu a connectar-vos per reprendre les actualitzacions de dades.",
  "common.add": "Afegeix",
  "common.addAStation": "Afegeix una estació",
  "common.addToFavorites": "Afegeix als preferits",
  "common.addYourOwnStation": "Afegeix la vostra pròpia estació",
  "common.alreadyPremium": "Ja teniu un compte premium!",
  "common.alsoAvailableOn": "També disponible a:",
  "common.altitude": "Altitud",
  "common.analysis": "Anàlisi",
  "common.aroundMe": "Al meu voltant",
  "common.articleCount": "{count, plural, one {# article} other {# articles}}",
  "common.articleNotFound": "No s'ha trobat l'article",
  "common.articleNotFoundDescription": "L'article que busqueu no existeix.",
  "common.average": "Mitjana",
  "common.averageOverThePeriod": "Mitjana del període",
  "common.away": "Fora",
  "common.back": "Enrere",
  "common.backToHelpCenter": "Torna al Centre d'ajuda",
  "common.backToHome": "Torna a l'inici",
  "common.bad": "Dolent",
  "common.batteryLevel": "Nivell de bateria",
  "common.bestValue": "Millor relació qualitat-preu",
  "common.billingDetailsAndroid": "Per a l'oferta de prova gratuïta, no se us cobrarà res si cancel·leu 24 hores abans que caduqui el període introductori gratuït. Quan finalitzi la prova, podeu cancel·lar la subscripció a SmartMixin en qualsevol moment mitjançant la configuració del vostre compte de Google Play, o es renovarà automàticament. Això s'ha de fer 24 hores abans del final del període de subscripció per evitar que se us cobri un altre càrrec com el que es mostra al botó de dalt. Els pagaments de la subscripció es carregaran al vostre compte de Google Play en confirmar la compra i a l'inici de cada període de renovació.",
  "common.billingDetailsIos": "Per a l'oferta de prova gratuïta, no se us cobrarà res si cancel·leu 24 hores abans que caduqui el període introductori gratuït. Quan finalitzi la prova, podeu cancel·lar la subscripció a SmartMixin en qualsevol moment mitjançant la configuració del vostre compte de l'App Store, o es renovarà automàticament. Això s'ha de fer 24 hores abans del final del període de subscripció per evitar que se us cobri un altre càrrec com el que es mostra al botó de dalt. Els pagaments de la subscripció es carregaran al vostre compte de l'App Store en confirmar la compra i a l'inici de cada període de renovació.",
  "common.boilerOn": "Caldera ENCESA",
  "common.browseByCategory": "Explora per categoria",
  "common.calendarView": "Vista de calendari",
  "common.cancel": "Cancel·la",
  "common.cannotBeEmpty": "Aquest camp no pot estar buit.",
  "common.cardDetails": "Dades de la targeta",
  "common.categoryNotFound": "No s'ha trobat la categoria",
  "common.categoryNotFoundDescription": "Aquesta categoria no existeix o no té cap article.",
  "common.charts": "Gràfics",
  "common.chartView": "Vista de gràfic",
  "common.clearRecentLocations": "Esborra-ho tot",
  "common.close": "Tanca",
  "common.comparison": "Comparació",
  "common.contactMe": "Contacta amb mi",
  "common.currentDay": "Dia actual",
  "common.currentLocation": "Ubicació actual",
  "common.currentObservations": "Observacions actuals",
  "common.currentRainEvent": "Episodi de pluja actual",
  "common.currentRate": "Intensitat actual",
  "common.currentWeatherConditions": "Condicions actuals",
  "common.customizeComparisonMetrics": "Personalitza les mètriques",
  "common.customizeComparisonMetricsDescription": "Arrossegueu els elements per reordenar les mètriques de comparació. Toqueu la icona de l'ull per mostrar o amagar mètriques.",
  "common.customizeDashboard": "Personalitza",
  "common.customizeDashboardDescription": "Arrossegueu els elements per reordenar el vostre tauler. Toqueu la icona de l'ull per mostrar o amagar seccions.",
  "common.customizedStationName": "Nom personalitzat de l'estació",
  "common.dailyForecast": "Previsió diària",
  "common.dashboard": "Tauler",
  "common.default": "Predeterminat",
  "common.defaultForecastModelChip": "Predeterminat · {name}",
  "common.delete": "Elimina",
  "common.deleteAccount": "Elimina el vostre compte",
  "common.deleteAccountConfirmation": "Segur que voleu eliminar el vostre compte? Aquesta acció és irreversible.",
  "common.deleteAccountDescription": "Aquesta acció elimina el vostre compte i tota la vostra informació. No es pot desfer.",
  "common.details": "Detalls",
  "common.edit": "Edita",
  "common.editor": "Editor",
  "common.endTime": "Hora de finalització",
  "common.exitFullscreen": "Surt de la pantalla completa",
  "common.exploreWeatherMap": "Explora el mapa del temps",
  "common.favoriteLocations": "Preferits",
  "common.favoriteLocationsEmpty": "Podeu afegir fins a 5 ubicacions preferides.",
  "common.favoriteStations": "Estacions preferides",
  "common.feedbackHelpsImprove": "Els vostres comentaris ens ajuden a millorar els articles d'ajuda.",
  "common.feedbackReasonNotAnswer": "No respon la meva pregunta",
  "common.feedbackReasonOutdated": "La informació està desactualitzada",
  "common.feedbackReasonUnclear": "Les instruccions no són clares",
  "common.feedbackWhatWentWrong": "Quin ha estat el problema?",
  "common.filterStationDescription": "No mostris les estacions amb mesures poc fiables",
  "common.filterStations": "Filtra les estacions",
  "common.filterStationSourceDescription": "Seleccioneu els proveïdors d'estacions que voleu mostrar al mapa",
  "common.findStationsNearYou": "Troba estacions a prop teu",
  "common.firmwareVersion": "Versió del microprogramari",
  "common.forecast": "Previsió",
  "common.forecastComparisonDescription": "Compareu fàcilment els resultats dels models de previsió de diverses fonts",
  "common.forecastModelComparison": "Comparació de models de previsió",
  "common.forecastModelCoverage": "Cobertura",
  "common.forecastModelDescription": "Descripció",
  "common.forecastModelDescription_AROME": "Model d'alta resolució de Météo France que permet resoldre la convecció sobre l'Europa occidental amb una resolució d'1,3 km. El millor de la seva categoria per a previsions a curt termini a França; s'actualitza cada tres hores.",
  "common.forecastModelDescription_ARPEGE_EU": "Niu europeu del model ARPEGE de Météo France amb una resolució de 10 km. Previsions de mitjà termini sobre Europa, actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Model meteorològic numèric global de Météo France amb una resolució de 25 km, que arriba fins a uns 4 dies. S'actualitza quatre vegades al dia.",
  "common.forecastModelDescription_EC_GDPS": "Sistema Global de Predicció Determinista d'Environment Canada: un model mundial de mitjà termini amb una resolució de 15 km que arriba fins a 10 dies, actualitzat dues vegades al dia.",
  "common.forecastModelDescription_EC_RDPS": "Sistema Regional de Predicció Determinista d'Environment Canada: un model de mitjà termini sobre Amèrica del Nord amb una resolució de 10 km, actualitzat quatre vegades al dia.",
  "common.forecastModelDescription_GFS": "El model global de mitjà termini insígnia de la NOAA. Cobreix tot el planeta amb una resolució de 25 km fins a 16 dies, actualitzat quatre vegades al dia.",
  "common.forecastModelDescription_HRRR_CONUS": "High-Resolution Rapid Refresh de la NOAA: un model que permet resoldre la convecció sobre els Estats Units continentals amb una resolució de 3 km, actualitzat cada hora. El més adequat per a previsions a molt curt termini de tempestes i temps sever.",
  "common.forecastModelDescription_ICON_DE": "Model d'alta resolució del DWD que permet resoldre la convecció sobre Alemanya i els països del voltant amb una resolució de 2,2 km. Previsions a curt termini actualitzades dues vegades al dia.",
  "common.forecastModelDescription_ICON_EU": "Niu europeu del model ICON del DWD amb una resolució de 7 km que cobreix Europa i l'Atlàntic Nord. Previsions de mitjà termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_MET_NORWAY": "El servei obert de previsió meteorològica de l'Institut Meteorològic Noruec, que combina models nòrdics d'alta resolució amb dades de l'ECMWF per oferir previsions a tot el món de fins a 10 dies vista.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Niu AROME sobre les Antilles franceses (Guadalupe, Martinica) amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Niu AROME sobre la Guaiana Francesa amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Niu AROME sobre Nova Caledònia amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Niu AROME sobre la Polinèsia Francesa amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Niu AROME sobre la Reunió i Mayotte amb una resolució de 2,5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_NAM_CONUS": "Niu del model mesoescalar nord-americà de la NOAA sobre els Estats Units continentals amb una resolució de 5 km. Previsions a curt termini actualitzades quatre vegades al dia.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Model mesoescalar nord-americà de la NOAA que cobreix tota l'Amèrica del Nord amb una resolució de 32 km. Actualitzat quatre vegades al dia.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "La previsió insígnia de SmartMixin. Per a cada hora de la vostra ubicació, triem el millor model disponible —normalment un model regional d'alta resolució allà on n'hi ha (AROME a França, ICON-D2 a Alemanya, HRRR als Estats Units, ARPEGE Europa a tot el continent…) i recorrem a un model global a la resta— i després omplim els buits amb fonts veïnes. El resultat és una previsió única i contínua que cobreix qualsevol lloc del món fins a 14 dies, actualitzada automàticament cada vegada que s'actualitza qualsevol dels models subjacents.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "La previsió global propietària de Weatherflow que combina diversos models meteorològics numèrics amb observacions de la seva xarxa d'estacions meteorològiques Tempest. Horitzó mundial de 10 dies.",
  "common.forecastModelDetailTitle": "Model de previsió",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Aquest model cobreix tot el planeta.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Aquest model només cobreix una regió específica.",
  "common.forecastModelSpecifications": "Especificacions",
  "common.forecastSources": "Fonts de previsió",
  "common.freeAccount": "Compte gratuït",
  "common.freeSubscription": "Subscripció premium gratuïta",
  "common.freeTrialForPeriod": "Prova gratuïta de {period} dies",
  "common.frequency": "Freqüència",
  "common.full": "Complet",
  "common.fullscreen": "Pantalla completa",
  "common.getStartedFree": "Comença gratis",
  "common.getUnlimitedAccess": "Obteniu accés il·limitat a:",
  "common.good": "Bo",
  "common.hail": "Calamarsa",
  "common.help": "Ajuda",
  "common.helpCategoryAccount": "Compte",
  "common.helpCategoryBilling": "Facturació",
  "common.helpCategoryGettingStarted": "Primers passos",
  "common.helpCategoryProviders": "Proveïdors",
  "common.helpCategoryStations": "Estacions",
  "common.helpCategoryTroubleshooting": "Resolució de problemes",
  "common.helpCenter": "Centre d'ajuda",
  "common.helpCenterDescription": "Trobeu respostes a les preguntes més freqüents i apreneu a treure el màxim profit de SmartMixin.",
  "common.hg": "Protecció contra gelades",
  "common.hidden": "Amagat",
  "common.hiddenSensors": "Sensors amagats",
  "common.hiddenStations": "Estacions amagades",
  "common.hiddenStationsDescription": "Podeu tornar a mostrar una estació tocant la icona de l'ull que hi ha al costat.",
  "common.high": "Alt",
  "common.home": "Inici",
  "common.homeConnectService": "Teniu una estació meteorològica? Connecteu el vostre servei",
  "common.homeInformation": "Informació de la llar",
  "common.homeIntroduction": "Comenceu a connectar els vostres comptes externs per gaudir de les funcions de SmartMixin.",
  "common.homeName": "Nom de la llar",
  "common.homeSubtitle": "El vostre temps, tot en un sol lloc",
  "common.horizon": "Horitzó",
  "common.horizonValue": "fins a {value} hores",
  "common.iDontKnowYet": "Encara no ho sé",
  "common.indoor": "Interior",
  "common.lastRainEvent": "Últim episodi de pluja",
  "common.lastUpdate": "Última actualització",
  "common.legendHeavy": "Forta",
  "common.legendLight": "Feble",
  "common.legendLightningHelp": "El color mostra l'antiguitat de cada llamp durant els últims {minutes} minuts: els més recents en blanc i els més antics en vermell fosc.",
  "common.legendNewest": "Més recent",
  "common.legendOldest": "Més antic",
  "common.legendStationsHelp": "El color del marcador reflecteix el valor de la mètrica seleccionada.",
  "common.lightningDataAttribution": "Dades de llamps: Blitzortung.org",
  "common.lightningStrikes": "Llamps",
  "common.lightningStrikesDescription": "Mostra els llamps en temps real al mapa",
  "common.linkToSection": "Enllaç a aquesta secció",
  "common.loading": "S'està carregant",
  "common.location": "Ubicació",
  "common.locationAddedToFavorites": "Ubicació afegida als preferits",
  "common.locationNotGranted": "No s'ha concedit el permís d'ubicació. Permeteu l'accés a la vostra ubicació a la configuració del dispositiu.",
  "common.locationRemovedFromFavorites": "Ubicació eliminada dels preferits",
  "common.locations": "Ubicacions",
  "common.low": "Baix",
  "common.manage": "Gestiona",
  "common.manageAccount": "Gestiona el compte",
  "common.manageMySubscription": "Gestiona la meva subscripció",
  "common.manageSensors": "Gestiona els sensors",
  "common.manageSensorsDescription": "Arrossegueu els elements per reordenar els sensors. Toqueu la icona de l'ull per mostrar o amagar els sensors. Toqueu un nom per canviar-lo.",
  "common.manualBoost": "Impuls manual",
  "common.manualSetpointUntil": "Consigna manual fins a",
  "common.mapLayers": "Capes del mapa",
  "common.mapLegend": "Llegenda del mapa",
  "common.maxFavoriteLocationsReached": "Només podeu tenir fins a 5 ubicacions preferides. Elimineu-ne una per afegir-ne una altra.",
  "common.maximum": "Màxim",
  "common.measureToDisplay": "Mesura a mostrar",
  "common.medium": "Mitjà",
  "common.meshSize": "Mida de la quadrícula",
  "common.minimum": "Mínim",
  "common.minRead": "{minutes} min de lectura",
  "common.modifyFavoriteStations": "Modifica les estacions preferides",
  "common.modifyFavoriteStationsDescription": "Podeu reordenar les vostres estacions preferides arrossegant-les. També les podeu eliminar de la llista.",
  "common.moduleType": "Tipus de mòdul",
  "common.monthTotal": "Total del mes",
  "common.more": "Més",
  "common.moreInformation": "Més informació",
  "common.myLocation": "La meva ubicació",
  "common.nearbyWeatherStations": "Estacions meteorològiques properes",
  "common.next": "Següent",
  "common.nextHours": "Pròximes hores",
  "common.no": "No",
  "common.noAccountNeeded": "No cal cap compte",
  "common.noDataForThisPeriod": "No hi ha dades per a aquest període",
  "common.noLocationsFound": "No s'ha trobat cap ubicació",
  "common.noNetatmoWeatherStationYet": "Encara no teniu cap estació meteorològica Netatmo.",
  "common.noOutdoorModule": "No hi ha cap mòdul exterior funcional per a aquesta estació.",
  "common.noSearchResults": "Cap article coincideix amb la cerca",
  "common.noStationsFound": "No s'ha trobat cap estació",
  "common.noThermostatYet": "Encara no teniu cap termòstat.",
  "common.notNow": "Ara no",
  "common.notPurchasedYet": "Sembla que això encara no s'ha comprat.",
  "common.noWeatherStation": "Cap estació meteorològica",
  "common.noWeatherStationYet": "Encara no teniu cap estació meteorològica.",
  "common.numberOfActiveWarnings": "{warning_count} avisos meteorològics actius",
  "common.onThisPage": "En aquesta pàgina",
  "common.openSettings": "Obre la configuració",
  "common.orChooseMonthly": "O trieu mensual:",
  "common.outdatedModule": "Les dades d'aquest mòdul estan desactualitzades.",
  "common.outdoor": "Exterior",
  "common.outdoorTemperature": "Temperatura exterior",
  "common.pageNotFound": "Pàgina no trobada",
  "common.pageNotFoundDescription": "La pàgina que cerqueu no existeix o s'ha mogut.",
  "common.passwordUpdated": "S'ha actualitzat la contrasenya correctament.",
  "common.personalWeatherIntelligence": "La vostra intel·ligència meteorològica personal",
  "common.platformMobileApp": "Aplicació mòbil",
  "common.platformMobileOnly": "Només a l'aplicació mòbil",
  "common.platformWebApp": "Aplicació web",
  "common.platformWebOnly": "Només a l'aplicació web",
  "common.popularArticles": "Articles populars",
  "common.premiumAccount": "Compte Premium",
  "common.premiumDescription": "La subscripció Premium desbloqueja moltes funcions addicionals, com ara l'anàlisi meteorològica avançada, comparacions de gràfics, models de previsió regionals i molt més.",
  "common.premiumFeatureAlerts": "Alertes meteorològiques",
  "common.premiumFeatureAnalysis": "Anàlisi meteorològica avançada",
  "common.premiumFeatureCharts": "Comparacions de gràfics",
  "common.premiumFeatureExport": "Exportació de dades",
  "common.premiumFeatureForecast": "Models de previsió regionals",
  "common.premiumFeatureNotification": "Widget de la barra d'estat",
  "common.premiumFeatureTitle": "Funció Premium",
  "common.premiumFeatureWidgets": "Widgets de la pantalla d'inici",
  "common.pressureSummary": "Resum de pressió",
  "common.previous": "Anterior",
  "common.previousHours": "Hores anteriors",
  "common.profileUpdated": "S'ha actualitzat el perfil correctament.",
  "common.purchasedNetatmoPro": "Anteriorment vau comprar Netatmo Pro ({date}). Us dóna accés a un subconjunt de funcions premium. Subscriviu-vos a una de les ofertes següents si voleu tenir accés a totes les funcions premium.",
  "common.radarDataAttribution": "Dades del radar: RainViewer.com",
  "common.rain": "Pluja",
  "common.rainEvents": "Episodis de pluja",
  "common.rainfallMeasurement": "Mesura de la precipitació",
  "common.rainRadar": "Radar de pluja",
  "common.rainRadarDescription": "Mostra la superposició del radar de pluja al mapa",
  "common.rainSummary": "Resum de pluja",
  "common.range": "Interval",
  "common.recentLocations": "Recents",
  "common.recentLocationsEmpty": "El vostre historial recent és buit.",
  "common.recentStations": "Estacions recents",
  "common.relatedArticles": "Articles relacionats",
  "common.relay": "Repetidor",
  "common.removeFromFavorites": "Elimina dels preferits",
  "common.renameSensors": "Canvia el nom dels sensors",
  "common.resetZoom": "Restableix el zoom",
  "common.restorePurchase": "Restaura la compra",
  "common.room": "Habitació",
  "common.rooms": "Habitacions",
  "common.savingsPercent": "Estalvieu {percent}%",
  "common.searchArticles": "Cerca articles...",
  "common.searchForALocation": "Cerca una ubicació...",
  "common.searchForLocation": "Cerca una ubicació",
  "common.searchForWeatherStation": "Cerca una estació meteorològica",
  "common.searchResults": "Resultats de la cerca",
  "common.searchResultsEmpty": "No s'ha trobat cap resultat.",
  "common.searchResultsFound": "{count, plural, one {# resultat trobat} other {# resultats trobats}}",
  "common.searchStationsDescription": "Introduïu una ciutat, adreça o nom de lloc per trobar estacions meteorològiques properes.",
  "common.searchStationsHint": "Utilitzeu la barra de cerca de dalt per descobrir estacions meteorològiques a qualsevol ubicació del món.",
  "common.selectStationForComparison": "Seleccioneu una estació amb què comparar",
  "common.selectWeatherForecastProvider": "Trieu un proveïdor meteorològic",
  "common.serialNumber": "Número de sèrie",
  "common.share": "Comparteix",
  "common.shareOutdoorMeasures": "Comparteix les vostres mesures exteriors",
  "common.shareOutdoorMeasuresDescription": "Participeu en la comunitat de SmartMixin fent visibles les vostres mesures exteriors als altres. Les mesures interiors mai no es compartiran.",
  "common.shareYourWeather": "Comparteix el vostre temps",
  "common.signalStrength": "Intensitat del senyal",
  "common.skip": "Omet",
  "common.smartThermostat": "Termòstat intel·ligent",
  "common.smartValve": "Vàlvula intel·ligent",
  "common.snow": "Neu",
  "common.start": "Inici",
  "common.startFreeTrial": "Comença la prova gratuïta",
  "common.startTime": "Hora d'inici",
  "common.station": "estació",
  "common.stationAddedToFavorites": "Estació afegida als preferits",
  "common.stationComparison": "Comparació d'estacions",
  "common.stationComparisonDescription": "Compareu dades meteorològiques històriques amb una altra estació",
  "common.stationInformation": "Informació de l'estació",
  "common.stationName": "Nom de l'estació",
  "common.stationObservationsDescription": "Mostra les últimes observacions de les estacions meteorològiques",
  "common.stationRemovedFromFavorites": "Estació eliminada dels preferits",
  "common.stations": "estacions",
  "common.stationsNear": "Estacions a prop de",
  "common.stationType": "Tipus d'estació",
  "common.statusOffline": "Fora de línia",
  "common.statusOnline": "En línia",
  "common.statusStale": "Obsolet",
  "common.statusSyncing": "S'està sincronitzant",
  "common.stillNeedHelp": "Encara necessites ajuda?",
  "common.stillNeedHelpDescription": "Si aquest article no ha respost la teva pregunta, estaré encantat d'ajudar-te directament.",
  "common.subscribeNow": "Subscriu-te ara - sense prova",
  "common.sumOverThePeriod": "Acumulat durant el període",
  "common.switchToPremium": "Canvia a SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Resum de temperatura",
  "common.thankYouForFeedback": "Gràcies pels vostres comentaris!",
  "common.thenPrice": "després {price}",
  "common.timeSelection": "Selecció d'hora",
  "common.timezone": "Fus horari",
  "common.totalDuration": "Durada total",
  "common.tryAnotherLocation": "No hem pogut trobar cap estació meteorològica a prop d'aquesta ubicació. Proveu de cercar una àrea diferent.",
  "common.unknown": "Desconegut",
  "common.untilChanged": "Fins que es canviï",
  "common.untilTime": "Fins a les {time}",
  "common.upgrade": "Millora",
  "common.upgradeRequiredAndroid": "Cal actualitzar la vostra aplicació. Visiteu Google Play per actualitzar-la.",
  "common.upgradeRequiredIos": "Cal actualitzar la vostra aplicació. Visiteu l'App Store per actualitzar-la.",
  "common.validate": "Valida",
  "common.validEmail": "Cal una adreça de correu electrònic vàlida.",
  "common.very_low": "Molt baix",
  "common.visitNetatmoWebsite": "Visita el lloc web de Netatmo",
  "common.wasArticleHelpful": "Us ha estat útil aquest article?",
  "common.weatherCondition": "Condició meteorològica",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain és una font de dades addicional proporcionada mitjançant el Tempest Weather System, impulsada per la tecnologia Nearcast. Les dades de NC Rain són una estimació de l'acumulació mitjana de precipitació al voltant del vostre Tempest a escala de barri",
  "common.weatherForecastModels": "Models de previsió meteorològica",
  "common.weatherIntelligencePlatform": "La plataforma d'intel·ligència meteorològica",
  "common.weatherMap": "Mapa meteorològic",
  "common.weatherMapMetaDescription": "SmartMixin ofereix mapes meteorològics i de radar interactius de les condicions meteorològiques per a ubicacions d'arreu del món.",
  "common.weatherObservations": "Observacions meteorològiques",
  "common.weatherStation": "Estació meteorològica",
  "common.weatherStations": "Estacions meteorològiques",
  "common.welcome": "Us donem la benvinguda a SmartMixin!",
  "common.whenBackHome": "Quan tornareu a casa?",
  "common.wifiStrength": "Intensitat del WiFi",
  "common.wind": "Vent",
  "common.windMeasurement": "Mesura del vent",
  "common.windSpeed": "Velocitat del vent",
  "common.windSummary": "Resum del vent",
  "common.yearToDate": "Any fins ara",
  "common.yes": "Sí",
  "common.zoomImage": "Amplia la imatge",
  "forecastMaps.addColor": "Afegeix color",
  "forecastMaps.addLayer": "Afegeix capa",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Torna als mapes",
  "forecastMaps.browseMaps": "Explora els mapes",
  "forecastMaps.build": "Genera",
  "forecastMaps.buildCompleted": "Generació completada",
  "forecastMaps.builderMetaDescription": "Componeu mapes de previsió personalitzats a partir de capes de models meteorològics.",
  "forecastMaps.builderTitle": "Constructor de mapes",
  "forecastMaps.buildFailed": "La generació ha fallat. Torneu-ho a provar.",
  "forecastMaps.buildNotPossible": "Aquest mapa encara no es pot generar: no hi ha dades de previsió disponibles.",
  "forecastMaps.buildProgress": "S'està renderitzant… {completed}/{total} passos",
  "forecastMaps.buildStarting": "S'està iniciant la generació…",
  "forecastMaps.byModel": "Per model",
  "forecastMaps.byZone": "Per zona",
  "forecastMaps.colormap": "Mapa de colors",
  "forecastMaps.colormapCustom": "Colors personalitzats",
  "forecastMaps.colormapGroupDomain": "Predefinits meteorològics",
  "forecastMaps.colormapGroupMatplotlib": "Predefinits científics",
  "forecastMaps.comingSoon": "Aquesta vista arribarà aviat.",
  "forecastMaps.contourLevels": "Nivells de contorn",
  "forecastMaps.countryCanada": "Canadà",
  "forecastMaps.countryFrance": "França",
  "forecastMaps.countryGermany": "Alemanya",
  "forecastMaps.countryItaly": "Itàlia",
  "forecastMaps.countryScandinavia": "Escandinàvia",
  "forecastMaps.countrySpain": "Espanya",
  "forecastMaps.countrySwitzerland": "Suïssa",
  "forecastMaps.countryUnitedStates": "Estats Units",
  "forecastMaps.customColormapMinColors": "Un mapa de colors personalitzat necessita almenys dos colors",
  "forecastMaps.customExtent": "Extensió personalitzada",
  "forecastMaps.deleteMap": "Elimina el mapa",
  "forecastMaps.deleteMapBody": "«{name}» i les seves execucions renderitzades s'eliminaran permanentment.",
  "forecastMaps.deleteMapTitle": "Voleu eliminar aquest mapa?",
  "forecastMaps.displayName": "Nom visible",
  "forecastMaps.downloadMp4": "Baixa MP4",
  "forecastMaps.downscaling": "Factor d'aprimament de barbes",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Dibuixa l'àrea",
  "forecastMaps.east": "Est",
  "forecastMaps.editMap": "Edita el mapa",
  "forecastMaps.exportBuilding": "S'està preparant el vídeo…",
  "forecastMaps.exportError": "L'exportació del vídeo ha fallat. Torneu-ho a provar.",
  "forecastMaps.exportMp4": "Exporta MP4",
  "forecastMaps.exportNotReady": "El vídeo encara no està a punt. Torneu-ho a provar més tard.",
  "forecastMaps.extentDrawHint": "Arrossegueu pel mapa per dibuixar l'àrea",
  "forecastMaps.extentInvalid": "L'oest ha de ser menor que l'est i el sud menor que el nord",
  "forecastMaps.extentPanZoomHint": "Desplaceu i amplieu fins que l'àrea ompli el marc",
  "forecastMaps.flipbookView": "Animació",
  "forecastMaps.forecastModel": "Model de previsió",
  "forecastMaps.forkAndEdit": "Bifurca i edita",
  "forecastMaps.height": "Alçada (polzades)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Color no vàlid — utilitzeu #RRGGBB",
  "forecastMaps.layers": "Capes",
  "forecastMaps.layerTypeBarbs": "Barbes de vent",
  "forecastMaps.layerTypeContour": "Línies de contorn",
  "forecastMaps.layerTypeFilledContour": "Contorns emplenats",
  "forecastMaps.layerTypeMagnitude": "Magnitud",
  "forecastMaps.layerTypeRaster": "Ràster",
  "forecastMaps.layerTypeVectorField": "Camp vectorial",
  "forecastMaps.leave": "Surt",
  "forecastMaps.levelsCount": "Recompte",
  "forecastMaps.levelsInvalid": "Nivells de contorn no vàlids",
  "forecastMaps.levelsModeArange": "Pas fix",
  "forecastMaps.levelsModeExplicit": "Valors explícits",
  "forecastMaps.levelsModeLinspace": "Espaiats uniformement (recompte)",
  "forecastMaps.levelsStep": "Pas",
  "forecastMaps.levelsValues": "Valors",
  "forecastMaps.levelsValuesHint": "Separats per comes, ascendents",
  "forecastMaps.localTimeHint": "Mostrat en la vostra hora local",
  "forecastMaps.map": "Mapa",
  "forecastMaps.mapDescription": "Descripció",
  "forecastMaps.mapName": "Nom del mapa",
  "forecastMaps.mapNameRequired": "Introduïu un nom",
  "forecastMaps.mapSettings": "Configuració del mapa",
  "forecastMaps.mapView": "Mapa interactiu",
  "forecastMaps.maxLayersReached": "Aquest mapa ha arribat al màxim de {max} capes.",
  "forecastMaps.maxValue": "Valor màxim",
  "forecastMaps.memoryBudgetExceeded": "La resolució supera el pressupost de renderització — reduïu el DPI o l'alçada",
  "forecastMaps.memoryBudgetUsage": "Pressupost de renderització: {percent}%",
  "forecastMaps.metaDescription": "Mapes de previsió animats renderitzats a partir d'execucions de models meteorològics.",
  "forecastMaps.metric": "Mètrica",
  "forecastMaps.metricRequired": "Seleccioneu una mètrica",
  "forecastMaps.metricUnavailable": "No disponible per a aquest model",
  "forecastMaps.minBelowMax": "El mínim ha de ser menor que el màxim",
  "forecastMaps.minMaxRequired": "Els valors mínim i màxim són obligatoris per a aquest tipus de capa",
  "forecastMaps.minValue": "Valor mínim",
  "forecastMaps.modelNoRun": "Encara no hi ha cap execució completada",
  "forecastMaps.moveLayerDown": "Mou avall",
  "forecastMaps.moveLayerUp": "Mou amunt",
  "forecastMaps.myMaps": "Els meus mapes",
  "forecastMaps.nanClipToMin": "Retalla al mínim",
  "forecastMaps.nanMask": "Màscara",
  "forecastMaps.nanPolicy": "Dades absents",
  "forecastMaps.nanSkip": "Omet",
  "forecastMaps.newMap": "Mapa nou",
  "forecastMaps.noCompletedRun": "Aquest mapa encara no s'ha renderitzat. Torneu-hi aviat.",
  "forecastMaps.noLayers": "Encara no hi ha capes. Afegiu una capa per començar.",
  "forecastMaps.noMapsAvailable": "Encara no hi ha cap mapa de previsió disponible.",
  "forecastMaps.north": "Nord",
  "forecastMaps.opacity": "Opacitat",
  "forecastMaps.overlayLegend": "Llegenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Reprodueix",
  "forecastMaps.pointValueError": "No s'ha pogut carregar la previsió per a aquest punt.",
  "forecastMaps.pointValueLoading": "S'està carregant la previsió…",
  "forecastMaps.pointValueUnavailable": "No hi ha dades per a aquesta hora.",
  "forecastMaps.presets": "Predefinits",
  "forecastMaps.preview": "Vista prèvia",
  "forecastMaps.previewEmptyHint": "Configureu almenys una capa vàlida per renderitzar una vista prèvia.",
  "forecastMaps.previewFailed": "La vista prèvia ha fallat",
  "forecastMaps.previewHour": "Hora de previsió",
  "forecastMaps.previewRendering": "S'està renderitzant la vista prèvia…",
  "forecastMaps.projection": "Projecció",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Estereogràfica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "Amèrica del Nord",
  "forecastMaps.removeColor": "Elimina el color",
  "forecastMaps.removeLayer": "Elimina la capa",
  "forecastMaps.retry": "Torna-ho a provar",
  "forecastMaps.run": "Execució: {run}",
  "forecastMaps.save": "Desa",
  "forecastMaps.selectExtentOnMap": "Selecciona l'àrea al mapa",
  "forecastMaps.south": "Sud",
  "forecastMaps.title": "Mapes de previsió",
  "forecastMaps.uMetric": "Component U",
  "forecastMaps.unitConversion": "Conversió d'unitats",
  "forecastMaps.unitNone": "Cap",
  "forecastMaps.unsavedChangesBody": "Teniu canvis sense desar. Voleu sortir i descartar-los?",
  "forecastMaps.unsavedChangesTitle": "Canvis sense desar",
  "forecastMaps.useCurrentView": "Utilitza la vista actual",
  "forecastMaps.useModelDomain": "Desactivat: s'utilitza tot el domini del model",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "Les mètriques U i V han de ser diferents",
  "forecastMaps.validTime": "Vàlid a les {time}",
  "forecastMaps.valueBetween": "Ha d'estar entre {min} i {max}",
  "forecastMaps.variable": "Variable",
  "forecastMaps.viewMap": "Mostra el mapa",
  "forecastMaps.vMetric": "Component V",
  "forecastMaps.west": "Oest",
  "forecastMaps.windAnimation": "Animació del vent",
  "intro.locationDescription": "Activeu l'accés a la ubicació per obtenir prediccions meteorològiques precises adaptades a la vostra zona exacta — s'han acabat les previsions genèriques.",
  "intro.locationTitle": "Previsions fetes per a vós",
  "intro.notificationDescription": "Activeu les notificacions per rebre alertes oportunes sobre els canvis meteorològics que us importen — pluja, neu o condicions severes, just quan ho necessiteu saber.",
  "intro.notificationsTitle": "No us perdeu mai cap canvi de temps",
  "intro.readyDescription": "Gaudiu de previsions precises, informació meteorològica en temps real i dades d'estacions d'arreu del món — tot en una sola aplicació potent.",
  "intro.readyTitle": "Ja ho teniu tot a punt!",
  "intro.welcomeDescription": "Obteniu previsions hiperlocals amb la tecnologia de les principals agències meteorològiques — a més d'accés a més de 40.000 estacions meteorològiques d'arreu del món per veure les condicions reals, passades i presents.",
  "intro.welcomeTitle": "El vostre temps, reinventat",
  "landing.alerts": "Alertes",
  "landing.alertsDescription": "Creeu les vostres pròpies alertes i rebeu notificacions tan bon punt s'activin.",
  "landing.featureAlertsDescription": "Establiu llindars personalitzats per a qualsevol mètrica. Rebeu una notificació quan la temperatura baixi, comenci a ploure o s'aixequi el vent.",
  "landing.featureAlertsTitle": "Alertes intel·ligents",
  "landing.featureAnalyticsDescription": "Gràfics interactius, anàlisi de tendències i estadístiques detallades. Aprofundiu en les dades de temperatura, humitat, pressió, pluja i vent.",
  "landing.featureAnalyticsTitle": "Analítica avançada",
  "landing.featureExportDescription": "Baixeu les vostres dades meteorològiques com a fitxers CSV per fer-ne una anàlisi més detallada amb Excel, Google Sheets o les vostres eines preferides.",
  "landing.featureExportTitle": "Exporteu les vostres dades",
  "landing.featureForecastDescription": "Accediu a més de 10 models de previsió professionals, com ara ECMWF, GFS i models regionals. Compareu-los de costat per fer les vostres pròpies prediccions.",
  "landing.featureForecastTitle": "Compareu models de previsió",
  "landing.featureHistoryDescription": "Accediu a dades històriques amb escales horàries, diàries i mensuals. Exporteu a CSV per a recerca o arxius personals.",
  "landing.featureHistoryTitle": "Historial complet",
  "landing.featureMultiBrandDescription": "Connecteu Netatmo, Davis, Tempest, Ecowitt, Ambient Weather i més. S'ha acabat canviar d'una aplicació a una altra.",
  "landing.featureMultiBrandTitle": "Totes les marques, una aplicació",
  "landing.featuresSubtitle": "SmartMixin us dona les eines per analitzar, comparar i entendre les vostres dades meteorològiques com un professional.",
  "landing.featuresTitle": "Fet per als amants de les dades",
  "landing.finalCtaButton": "Crea un compte gratuït",
  "landing.finalCtaSubtitle": "Uniu-vos a milers d'aficionats a la meteorologia que confien en SmartMixin.",
  "landing.finalCtaTitle": "A punt per aprofundir en les vostres dades meteorològiques?",
  "landing.forecastDescription": "Accediu a alguns dels millors models de previsió meteorològica i compareu-los per fer-vos la vostra pròpia idea de quin temps farà.",
  "landing.forecasts": "Previsions",
  "landing.heroCta": "Comença gratis",
  "landing.heroDescription": "Analítica en profunditat, gràfics elegants i previsions professionals — totes les vostres estacions meteorològiques unificades en una sola aplicació potent.",
  "landing.heroSecondaryCta": "Explora el mapa",
  "landing.heroTagline": "Per als aficionats a la meteorologia",
  "landing.heroTitle": "Vegeu el vostre temps com mai abans",
  "landing.pricingFeatureAdvancedMetrics": "Mètriques avançades",
  "landing.pricingFeatureAlerts": "Alertes personalitzades",
  "landing.pricingFeatureExport": "Exportació de dades (CSV)",
  "landing.pricingFeatureForecastComparison": "Comparació de previsions",
  "landing.pricingFeatureForecasts": "Models de previsió",
  "landing.pricingFeatureForecastsFreeTier": "1 model",
  "landing.pricingFeatureForecastsPremiumTier": "més de 10 models",
  "landing.pricingFeatureReports": "Anàlisi i informes",
  "landing.pricingFeatureStationComparison": "Comparació d'estacions",
  "landing.pricingFeatureWidgets": "Widgets de pantalla d'inici",
  "landing.pricingFeatureYearOverYear": "Anàlisi interanual",
  "landing.pricingFree": "Gratuït",
  "landing.pricingFreeCta": "Comença",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "El més popular",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Comença",
  "landing.pricingPremiumDescription": "Des d'1,99 €/mes — subscriviu-vos al web, a l'App Store o a Google Play",
  "landing.pricingSubtitle": "Comenceu gratis, milloreu quan necessiteu més potència.",
  "landing.pricingTitle": "Preus senzills i transparents",
  "landing.smartMixinDescription": "SmartMixin és una aplicació que proporciona accés a la vostra estació meteorològica i a més de 40.000 estacions d'arreu del món. Us ajuda a veure i entendre les dades meteorològiques.",
  "landing.statBrands": "Marques compatibles",
  "landing.statForecasts": "Models de previsió",
  "landing.statStations": "Estacions meteorològiques",
  "landing.supportedDevices": "Dispositius compatibles",
  "landing.supportedDevicesDescription": "A més de les estacions de l'Organització Meteorològica Mundial, SmartMixin és compatible amb un nombre creixent de marques d'estacions meteorològiques.",
  "landing.supportedDevicesNote": "A més de més de 40.000 estacions públiques de l'Organització Meteorològica Mundial",
  "landing.supportedDevicesSubtitle": "Connecteu la vostra estació meteorològica existent en minuts. Som compatibles amb 8 marques importants i creixent.",
  "landing.supportedDevicesTitle": "Funciona amb la vostra estació",
  "landing.thermostatDescription": "Connecteu el vostre termòstat Netatmo per correlacionar els patrons de calefacció amb les condicions exteriors.",
  "landing.thermostatManufacturers": "També s'admeten fabricants de termòstats per correlacionar la calefacció amb les condicions exteriors.",
  "landing.thermostatTitle": "Integració amb la llar intel·ligent",
  "landing.weatherAnalysis": "Anàlisi meteorològica",
  "landing.weatherAnalysisDescription": "SmartMixin inclou moltes visualitzacions de dades que us permeten analitzar les dades meteorològiques.",
  "landing.weatherAssistant": "El vostre assistent meteorològic",
  "landing.weatherAssistantDescription": "Tant si us interessen les condicions meteorològiques actuals, històriques o de previsió, SmartMixin us ofereix nombroses anàlisis sempre que les necessiteu.",
  "landing.weatherForecastModels": "Models de previsió meteorològica",
  "landing.weatherForecastModelsDescription": "SmartMixin proporciona accés als models de previsió meteorològica més precisos. Podeu comparar-ne fàcilment les previsions i fer-vos la vostra pròpia idea.",
  "landing.weatherMap": "Mapa meteorològic",
  "landing.weatherMapDescription": "Navegueu pel mapa i visualitzeu quin temps fa a qualsevol lloc del món.",
  "network.cancelError": "S'ha cancel·lat la sol·licitud",
  "network.connectionError": "El servidor no està disponible",
  "network.networkError": "La xarxa no està disponible",
  "network.serverError": "Alguna cosa ha anat malament...",
  "network.timeoutError": "Temps de connexió esgotat",
  "network.unknownError": "Error desconegut",
  "providerHints.ambientWeatherApiKey": "Creada a la configuració del vostre compte d'ambientweather.net.",
  "providerHints.davisApiSecret": "Es mostra només un cop quan vau crear la clau API V2 — guardeu-la en un lloc segur.",
  "providerHints.davisV2ApiKey": "De la pàgina de claus API V2 del vostre compte de weatherlink.com.",
  "providerHints.ecowittApi": "De la pàgina d'API del vostre compte d'Ecowitt.",
  "providerHints.ecowittApp": "La clau d'aplicació (Application key), també del vostre compte d'Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Feu servir el correu electrònic i la contrasenya del vostre compte My AcuRite, no les credencials de SmartMixin.",
  "providerHints.myAcuriteEmail": "El correu electrònic del vostre compte My AcuRite, no les credencials de SmartMixin.",
  "providerHints.myAcuritePassword": "La contrasenya del vostre compte My AcuRite.",
  "providerHints.weatherflowToken": "Token d'ús personal de tempestwx.com → configuració → autoritzacions de dades.",
  "providerHints.wundergroundEditKey": "Utilitza una clau diferent",
  "providerHints.wundergroundKey": "Una cadena llarga de la pàgina de claus API de membre de Weather Underground, no la contrasenya de wunderground.com.",
  "providerHints.wundergroundKeyExample": "p. ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Clau API verificada",
  "providerHints.wundergroundKeyVerifying": "S'està comprovant la clau…",
  "providerHints.wundergroundNoStationsNearby": "No s'ha trobat cap estació a prop d'aquesta ubicació. Proveu d'introduir un identificador d'estació directament.",
  "providerHints.wundergroundStationId": "Qualsevol identificador d'estació de Weather Underground: la vostra o una estació pública a prop vostre.",
  "providerHints.wundergroundStationIdExample": "p. ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Obteniu la vostra clau API d'Ambient Weather.",
  "providerIntro.davisStep2": "Obteniu la vostra clau API i el secret API de Davis V2.",
  "providerIntro.ecowittStep2": "Obteniu la vostra clau API i clau d'aplicació d'Ecowitt.",
  "providerIntro.getStarted": "Comença",
  "providerIntro.myAcuriteStep2": "Feu servir el correu electrònic i la contrasenya del vostre compte My AcuRite actual.",
  "providerIntro.netatmoEnergyStep2": "Inicieu la sessió a Netatmo quan se us demani; no cal cap clau API.",
  "providerIntro.netatmoWeatherStep2": "Inicieu la sessió a Netatmo quan se us demani; no cal cap clau API.",
  "providerIntro.signupBanner": "Ja gairebé hi sou: creeu el vostre compte gratuït de SmartMixin per connectar {provider}.",
  "providerIntro.step1": "Inicieu la sessió al vostre compte de SmartMixin (NO amb les credencials de {provider}).",
  "providerIntro.step3EmailPassword": "Introduïu-los aquí.",
  "providerIntro.step3KeyOrToken": "Enganxeu-ho aquí.",
  "providerIntro.step3OAuth": "Autoritzeu SmartMixin a la finestra emergent.",
  "providerIntro.step3Wunderground": "Enganxeu la vostra clau API i, tot seguit, trieu una estació propera o introduïu qualsevol identificador d'estació.",
  "providerIntro.title": "Connecta {provider}",
  "providerIntro.weatherflowStep2": "Obteniu el vostre token d'ús personal de Tempest.",
  "providerIntro.wundergroundBrowsePublic": "No teniu cap estació? Exploreu-ne de públiques",
  "providerIntro.wundergroundFindNearby": "Cerca estacions a prop meu",
  "providerIntro.wundergroundOrEnterId": "O introduïu un identificador d'estació",
  "providerIntro.wundergroundStep2": "Obteniu la vostra clau API de Weather Underground. Després podreu connectar qualsevol estació: la vostra o una de pública.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Anàlisi",
  "reports.annualCumulativeRainfallComparison": "Comparació de la precipitació acumulada anual",
  "reports.annualHeatingDurationComparison": "Comparació de la durada de la calefacció anual",
  "reports.annualHeatingEfficiency": "Eficiència de calefacció anual",
  "reports.annualIndoorComparison": "Comparació d'interior anual",
  "reports.annualIndoorReport": "Informe d'interior anual",
  "reports.annualOutdoorComparison": "Comparació d'exterior anual",
  "reports.annualOutdoorReport": "Informe d'exterior anual",
  "reports.annualReport": "Informe anual",
  "reports.annualSolarReport": "Informe solar anual",
  "reports.annualWaterBalance": "Balanç hídric anual",
  "reports.annualWaterBalanceCarryOver": "Trasllada l'any anterior",
  "reports.annualWaterBalanceDescription": "El balanç hídric (versió simplificada, només s'utilitzen la pluja i l'evapotranspiració) ajuda a gestionar el subministrament d'aigua",
  "reports.avgHumidity": "Humitat mitjana",
  "reports.avgMaxTemperature": "T°max mitjana",
  "reports.avgMetric": "Mitjana – {metric}",
  "reports.avgMinTemperature": "T°min mitjana",
  "reports.avgPressure": "Pressió mitjana",
  "reports.avgTemperature": "Temperatura mitjana",
  "reports.comfortable": "Confortable (45% {lessThan} Humitat ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitació acumulada",
  "reports.cumulativeRainfallDescription": "Feu un seguiment de la precipitació total acumulada durant el període seleccionat.",
  "reports.dailyMaxRainfall": "Precipitació màx. diària",
  "reports.dataExport": "Exporta les dades",
  "reports.dataExportXlsxFormatDescription": "Exporteu totes les dades de la vostra estació en format Excel (*.xlsx). Un cop feu clic al botó, rebreu un correu electrònic amb les dades processades al cap d'uns minuts.",
  "reports.daysWithFrost": "Dies amb gelada",
  "reports.daysWithoutThaw": "Dies sense desglaç",
  "reports.daysWithStrongFrost": "Dies amb gelada forta",
  "reports.emailSent": "S'ha enviat un correu electrònic a la vostra bústia",
  "reports.grasslandTemperatureSum": "Suma de temperatura de prats",
  "reports.grasslandTemperatureSumDescription": "Si a la primavera se supera la suma de {threshold}, s'ha assolit l'inici sostenible de la vegetació (funciona a Europa)",
  "reports.growingDegreeDays": "Graus dia de creixement",
  "reports.highPressure": "Anticicló (Pressió mitjana ≥ 1013mbar)",
  "reports.indoorReport": "Informe d'interior",
  "reports.keyFacts": "Dades clau",
  "reports.longestRunOfRainyDays": "Ratxa més llarga de dies plujosos",
  "reports.longestRunWithoutRun": "Ratxa més llarga sense pluja",
  "reports.lowPressure": "Baixa pressió (Pressió mitjana {lessThan} 1013mbar)",
  "reports.maxHumidity": "Humitat màxima",
  "reports.maxMetric": "Màxim – {metric}",
  "reports.maxPressure": "Pressió màxima",
  "reports.maxPressureMagnitude24h": "Magnitud màxima (/24H)",
  "reports.maxTemperature": "Temperatura màxima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Magnitud màxima (/24H)",
  "reports.minHumidity": "Humitat mínima",
  "reports.minMetric": "Mínim – {metric}",
  "reports.minPressure": "Pressió mínima",
  "reports.minPressureMagnitude24h": "Magnitud mínima (/24H)",
  "reports.minTemperature": "Temperatura mínima",
  "reports.minTempMagnitude24h": "Magnitud mínima (/24H)",
  "reports.monthlyHeatingEfficiency": "Eficiència de calefacció mensual",
  "reports.monthlyIndoorReport": "Informe d'interior mensual",
  "reports.monthlyOutdoorReport": "Informe d'exterior mensual",
  "reports.monthlyReport": "Informe mensual",
  "reports.monthlySolarReport": "Informe solar mensual",
  "reports.monthlyWindReport": "Informe del vent mensual",
  "reports.numberOfDays": "Nombre de dies",
  "reports.outdoorReport": "Informe d'exterior",
  "reports.rainfall": "Precipitació",
  "reports.rainyDays": "Dies plujosos",
  "reports.relativelyWet": "Relativament humit (60% {lessThan} Humitat ≤ 80%)",
  "reports.sendEmail": "Envia el correu electrònic",
  "reports.tooDry": "Massa sec (Humitat ≤ 45%)",
  "reports.tooWet": "Massa humit (Humitat {greaterThan} 80%)",
  "reports.tropicalNights": "Nits tropicals",
  "reports.waterBalance": "Balanç hídric",
  "reports.yearToDateTemperature": "Temperatura de l'any fins ara",
  "reports.yearToDateTemperatureComparison": "Comparació de la temperatura de l'any fins ara",
  "sensors.aqiByChannel": "AQI per canal",
  "sensors.bgtSensors": "Globus negre i WBGT",
  "sensors.cameraFeed": "Càmera",
  "sensors.compareAqi": "Compara l'AQI",
  "sensors.compareHumidity": "Compara la humitat",
  "sensors.compareMoisture": "Compara la humitat del sòl",
  "sensors.comparePm25": "Compara el PM2.5",
  "sensors.compareTemperatures": "Compara les temperatures",
  "sensors.depthByChannel": "Profunditat per canal",
  "sensors.heatStressExtreme": "Estrès tèrmic extrem",
  "sensors.heatStressModerate": "Estrès tèrmic moderat",
  "sensors.heatStressNone": "Sense estrès tèrmic",
  "sensors.heatStressStrong": "Estrès tèrmic fort",
  "sensors.heatStressVeryStrong": "Estrès tèrmic molt fort",
  "sensors.humidityByChannel": "Humitat per canal",
  "sensors.indoorAirQuality": "Qualitat de l'aire interior",
  "sensors.indoorAirQualityPm": "AQI de PM2.5 i PM10",
  "sensors.indoorClimate": "Clima interior",
  "sensors.indoorCo2Levels": "Nivells de CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura i humitat",
  "sensors.last24Hours": "24 hores",
  "sensors.last30Days": "30 dies",
  "sensors.last7Days": "7 dies",
  "sensors.leafTemperatureByChannel": "Temperatura de la fulla per canal",
  "sensors.leafWetnessByChannel": "Humectació foliar per canal",
  "sensors.lightningSensor": "Llamps",
  "sensors.moistureByChannel": "Humitat del sòl per canal",
  "sensors.noDataAvailable": "No hi ha dades disponibles",
  "sensors.pm10AndAqi": "PM10 i AQI",
  "sensors.pm1AndAqi": "PM1.0 i AQI",
  "sensors.pm25AndAqi": "PM2.5 i AQI",
  "sensors.pm25ByChannel": "PM2.5 per canal",
  "sensors.pm4AndAqi": "PM4.0 i AQI",
  "sensors.selectChannel": "Selecciona el canal",
  "sensors.sensorDetailDescription": "Consulteu les dades històriques i les tendències dels canals dels vostres sensors.",
  "sensors.sensorHistory": "Historial del sensor",
  "sensors.soilConductivityByChannel": "Conductivitat per canal",
  "sensors.soilTemperatureByChannel": "Temperatura del sòl per canal",
  "sensors.strikesToday": "Impactes avui",
  "sensors.temperatureByChannel": "Temperatura per canal",
  "sensors.viewChart": "Mostra el gràfic",
  "settings.about": "Quant a",
  "settings.aboutDescription": "Acord de llicència, política de privadesa",
  "settings.account": "Perfil i seguretat",
  "settings.accountDescription": "Nom, contrasenya, elimina el compte",
  "settings.accountIntro": "Les dades fan referència al vostre compte:",
  "settings.accountSection": "Compte",
  "settings.appearance": "Aparença",
  "settings.appearanceDescription": "Tema i opcions de visualització",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "àrab",
  "settings.availableServices": "Disponibles",
  "settings.bulgarian": "búlgar",
  "settings.cannotDisconnectLastAccount": "No es pot desconnectar l'únic mètode d'inici de sessió. Afegiu primer un altre mètode d'inici de sessió.",
  "settings.catalan": "català",
  "settings.changeEmail": "Canvia el correu electrònic",
  "settings.changePassword": "Canvia la contrasenya",
  "settings.chartGestures": "Gestos als gràfics",
  "settings.chartGesturesDescription": "Fer lliscar el dit pels gràfics canvia el període de temps; pessigar-los canvia l'escala de temps",
  "settings.connect": "Connecta",
  "settings.connected": "Connectat",
  "settings.connectedAccounts": "Comptes connectats",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Connectats",
  "settings.connectedSince": "Connectat des del {date}",
  "settings.connectionSuccess": "El compte de {provider} s'ha connectat correctament",
  "settings.contactUs": "Contacteu-nos",
  "settings.contactUsDescription": "Obteniu ajuda o envieu comentaris",
  "settings.croatian": "croat",
  "settings.currentPassword": "Contrasenya actual",
  "settings.czech": "txec",
  "settings.danish": "danès",
  "settings.dark": "Tema fosc",
  "settings.dataDisplay": "Visualització de dades",
  "settings.dateAndTime": "Data i hora",
  "settings.disconnect": "Desconnecta",
  "settings.disconnectConfirmation": "Segur que voleu desconnectar el vostre compte de {provider}?",
  "settings.disconnectionSuccess": "El compte de {provider} s'ha desconnectat correctament",
  "settings.donateButton": "Fes una donació",
  "settings.donateDescription": "SmartMixin està desenvolupat per un equip petit. Si us resulta útil, podeu donar suport al seu desenvolupament amb una donació única de qualsevol import. És un regal: no canvia el vostre pla ni desbloqueja cap funció.",
  "settings.donateSuccessBody": "La vostra donació ajuda a mantenir SmartMixin en funcionament i a millorar-lo. Us ho agraïm de tot cor.",
  "settings.donateSuccessTitle": "Gràcies pel vostre suport!",
  "settings.donateTitle": "Doneu suport a SmartMixin",
  "settings.dutch": "neerlandès",
  "settings.emailChange": "Canvia l'adreça de correu electrònic",
  "settings.emailChangeConfirmation": "Confirmació del canvi de correu electrònic",
  "settings.emailChangeFailure": "L'enllaç de canvi de correu electrònic no és vàlid o ha caducat.",
  "settings.emailChangeSuccess": "El vostre correu electrònic s'ha canviat correctament a {newEmail}.",
  "settings.emailChangeVerificationSent": "S'ha enviat un correu electrònic de verificació a la vostra nova adreça de correu electrònic. Comproveu la safata d'entrada i feu clic a l'enllaç per confirmar el canvi.",
  "settings.english": "anglès",
  "settings.forecastModelOrderEmpty": "No s'ha desat cap ordre; fem servir GFS de manera predeterminada.",
  "settings.forecastModelOrderFreeHint": "Els models premium requereixen una subscripció SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Triem el primer model de la vostra llista que cobreix cada estació.",
  "settings.forecastModelOrderReset": "Restableix als valors predeterminats",
  "settings.forecastModelOrderTitle": "Model de previsió predeterminat",
  "settings.forecastModels": "Models de previsió",
  "settings.forecastModelsDescription": "Reordena per preferència",
  "settings.french": "francès",
  "settings.german": "alemany",
  "settings.gestures": "Gestos",
  "settings.greek": "grec",
  "settings.helpCenter": "Centre d'ajuda",
  "settings.helpCenterDescription": "Preguntes freqüents i guies",
  "settings.hungarian": "hongarès",
  "settings.integrationsSection": "Integracions",
  "settings.italian": "italià",
  "settings.japanese": "japonès",
  "settings.korean": "coreà",
  "settings.language": "Idioma",
  "settings.languageDescription": "Idioma preferit",
  "settings.light": "Tema clar",
  "settings.newEmailAddress": "Nova adreça de correu electrònic",
  "settings.newPassword": "Nova contrasenya",
  "settings.newPasswordAgain": "Repetiu la nova contrasenya",
  "settings.norwegian": "noruec",
  "settings.notConnected": "No connectat",
  "settings.notificationsSection": "Notificacions",
  "settings.oldPassword": "Contrasenya antiga",
  "settings.ongoingNotificationEnabled": "Activa la notificació permanent",
  "settings.ongoingNotificationMetrics": "Mètriques mostrades",
  "settings.ongoingNotificationMetricsHint": "Arrossegueu per reordenar les mètriques seleccionades",
  "settings.ongoingNotificationPermissionRequired": "Cal el permís de notificacions",
  "settings.ongoingNotificationStation": "Estació meteorològica",
  "settings.passwordChange": "Canvi de contrasenya",
  "settings.polish": "polonès",
  "settings.portuguese": "portuguès",
  "settings.preferencesSection": "Preferències",
  "settings.premium": "SmartMixin Premium",
  "settings.premiumActive": "Activa",
  "settings.premiumAnnualThenPrice": "Després, 9.99 €/any",
  "settings.premiumAnnualTrialInfo": "Comenceu amb una prova gratuïta de {days} dies",
  "settings.premiumCurrentPlan": "Pla actual",
  "settings.premiumDescription": "Gestioneu la vostra subscripció",
  "settings.premiumDownloadApp": "Descarregueu l'aplicació per subscriure-us:",
  "settings.premiumExpiresOn": "Es renova el {date}",
  "settings.premiumFreePlan": "Gratuït",
  "settings.premiumInactive": "Sense subscripció",
  "settings.premiumManageWebSubscription": "Gestioneu la vostra subscripció, actualitzeu el mètode de pagament o cancel·leu-la.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Subscriu-te anualment",
  "settings.premiumSubscribedOn": "Subscrit a {platform}",
  "settings.premiumSubscribeMonthly": "Subscriu-te mensualment",
  "settings.premiumSubscribeOnWeb": "Subscriviu-vos ara per desbloquejar totes les funcions premium.",
  "settings.premiumSubscriptionSuccess": "La vostra subscripció s'ha activat! Gaudiu de totes les funcions premium.",
  "settings.premiumSubscriptionSuccessTitle": "Us donem la benvinguda a Premium!",
  "settings.premiumWebappNotice": "Les subscripcions només es poden adquirir a través de l'aplicació mòbil de SmartMixin per a iOS o Android.",
  "settings.privacyPolicy": "Política de privadesa",
  "settings.profile": "Perfil",
  "settings.russian": "rus",
  "settings.serbian": "serbi",
  "settings.settings": "Configuració",
  "settings.slovak": "eslovac",
  "settings.smallDecimals": "Decimals petits",
  "settings.smallDecimalsDescription": "Mostra els dígits decimals en una mida més petita",
  "settings.socialConnectionsIntro": "Vinculeu els vostres comptes socials per activar l'inici de sessió ràpid. Podeu connectar o desconnectar comptes en qualsevol moment.",
  "settings.spanish": "espanyol",
  "settings.statusBarWidget": "Widget de la barra d'estat",
  "settings.statusBarWidgetDescription": "Dades meteorològiques sempre visibles",
  "settings.subscriptionSection": "Subscripció",
  "settings.supportSection": "Assistència",
  "settings.swedish": "suec",
  "settings.systemTheme": "Tema del sistema",
  "settings.termsOfService": "Condicions del servei",
  "settings.turkish": "turc",
  "settings.ukrainian": "ucraïnès",
  "settings.units": "Unitats",
  "settings.unitsDescription": "Unitats de mesura mostrades dins de l'aplicació",
  "settings.update": "Actualitza",
  "settings.updateYourProfile": "Actualitzeu el vostre perfil",
  "settings.weatherServices": "Serveis meteorològics",
  "settings.weatherServicesConnected": "{count, plural, =0 {Cap servei connectat} one {# servei connectat} other {# serveis connectats}}",
  "settings.weatherServicesDescription": "Connecteu Netatmo, Davis, Weatherflow i més",
  "settings.windDirectionConvention": "Fletxa de direcció del vent",
  "settings.windDirectionConventionDescription": "Trieu com es mostren les fletxes de direcció del vent",
  "settings.windDirectionMeteorological": "Direcció d'origen",
  "settings.windDirectionMeteorologicalDescription": "La fletxa apunta d'on ve el vent (convenció meteorològica)",
  "settings.windDirectionOceanographic": "Direcció del flux",
  "settings.windDirectionOceanographicDescription": "La fletxa apunta cap on bufa el vent (convenció oceanogràfica)",
  "units.absolutePressure": "Pressió absoluta",
  "units.airDensity": "Densitat de l'aire",
  "units.airGap": "Espai d'aire",
  "units.apparentTemperature": "Temperatura aparent",
  "units.AQI": "AQI",
  "units.AQI_24H": "AQI 24h",
  "units.avg": "Mitj.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. de globus negre",
  "units.boilerOn": "Caldera encesa",
  "units.co2": "CO2",
  "units.conductivity": "Conductivitat",
  "units.coolingDegreeDays": "Graus dia de refrigeració",
  "units.dailyHeatingDuration": "Durada diària de calefacció",
  "units.dailyPrecipitation": "Precipitació diària",
  "units.dailyRain": "Pluja diària",
  "units.degreeDay": "Grau dia",
  "units.degreeDayShort": "GD",
  "units.depth": "Profunditat",
  "units.depthSensors": "Sensors de profunditat",
  "units.dewPoint": "Punt de rosada",
  "units.distance": "Distància",
  "units.downTrend": "descendent",
  "units.E": "E",
  "units.E_long": "Est",
  "units.ENE": "ENE",
  "units.ENE_long": "Est-nord-est",
  "units.ESE": "ESE",
  "units.ESE_long": "Est-sud-est",
  "units.ET": "Evapotranspiració",
  "units.ETshort": "ET",
  "units.feelLike": "Sensació tèrmica",
  "units.feelsLike": "Sensació tèrmica",
  "units.footMile": "Peu, milla",
  "units.frostPoint": "Punt de gebrada",
  "units.gust": "Ràfega",
  "units.heatIndex": "Índex de calor",
  "units.heatingDegreeDays": "Graus dia de calefacció",
  "units.heatingPower": "Potència de calefacció",
  "units.humidex": "Humidex",
  "units.humidity": "Humitat",
  "units.inch": "Polzada",
  "units.inchOfMercury": "Polzada de mercuri",
  "units.kilometerPerHour": "Quilòmetres per hora",
  "units.knot": "Nus",
  "units.last12Hours": "Últimes 12 hores",
  "units.last24Hours": "Últimes 24 hores",
  "units.last3Hours": "Últimes 3 hores",
  "units.last6Hours": "Últimes 6 hores",
  "units.lastHour": "Última hora",
  "units.lastLightningImpact": "Últim impacte",
  "units.lastMeasure": "Última mesura",
  "units.leafSensors": "Sensors foliars",
  "units.leafWetness": "Humectació foliar",
  "units.lightningDistance": "Distància",
  "units.lightningStrikeCount": "Nombre de llamps",
  "units.lightningStrikeDistance": "Distància dels llamps",
  "units.max": "Màx.",
  "units.max_gust": "Ràfega màx.",
  "units.max_wind": "Vent màx.",
  "units.meterKilometer": "Metre, quilòmetre",
  "units.meterPerSecond": "Metres per segon",
  "units.milePerHour": "Milles per hora",
  "units.millibar": "Mil·libar",
  "units.millimeter": "Mil·límetre",
  "units.millimeterOfMercury": "Mil·límetre de mercuri",
  "units.min": "Mín.",
  "units.N": "N",
  "units.N_long": "Nord",
  "units.NE": "NE",
  "units.NE_long": "Nord-est",
  "units.NNE": "NNE",
  "units.NNE_long": "Nord-nord-est",
  "units.NNW": "NNO",
  "units.NNW_long": "Nord-nord-oest",
  "units.noise": "Soroll",
  "units.normalizedHeatingCoefficient": "Coeficient de calefacció normalitzat",
  "units.NW": "NO",
  "units.NW_long": "Nord-oest",
  "units.O3": "Ozó",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "Precipitació",
  "units.pressure": "Pressió",
  "units.rain": "Pluja",
  "units.rainRate": "Intensitat de pluja",
  "units.referenceTemperature": "Temperatura de referència",
  "units.relativePressure": "Pressió relativa",
  "units.S": "S",
  "units.S_long": "Sud",
  "units.SE": "SE",
  "units.SE_long": "Sud-est",
  "units.setPoint": "Consigna",
  "units.snow": "Neu",
  "units.snowfall": "Nevada",
  "units.soilMoisture": "Humitat",
  "units.soilSensors": "Sensors del sòl",
  "units.solarEnergy": "Energia solar",
  "units.solarRadiation": "Radiació solar",
  "units.speed": "Velocitat",
  "units.SSE": "SSE",
  "units.SSE_long": "Sud-sud-est",
  "units.SSW": "SSO",
  "units.SSW_long": "Sud-sud-oest",
  "units.stableTrend": "estable",
  "units.sum": "Suma",
  "units.SW": "SO",
  "units.SW_long": "Sud-oest",
  "units.temperature": "Temperatura",
  "units.temperatureAndHumiditySensors": "Sensors de temperatura i humitat",
  "units.temperatureSensors": "Sensors de temperatura i humitat",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Avui",
  "units.upTrend": "ascendent",
  "units.uv": "UV",
  "units.visibility": "Visibilitat",
  "units.W": "O",
  "units.W_long": "Oest",
  "units.wetBulbGlobeTemperature": "Temp. de globus de bulb humit",
  "units.wetBulbTemperature": "Temp. de bulb humit",
  "units.wind": "Vent",
  "units.windChill": "Sensació de fred",
  "units.windDirection": "Direcció del vent",
  "units.windRun": "Recorregut del vent",
  "units.windRunDescription": "El recorregut del vent és la distància total que ha recorregut el vent durant un període de temps",
  "units.WNW": "ONO",
  "units.WNW_long": "Oest-nord-oest",
  "units.WSW": "OSO",
  "units.WSW_long": "Oest-sud-oest"
}
